import type { RefObject } from 'react';
import { useCallback, useState } from 'react';

import useLayoutEffect from '@swf/core/hooks/useIsomorphicLayoutEffect';

const clientMaxWidth = 850;

const useScrollGradient = (isSeoMenu: boolean, seoMenuRef: RefObject<HTMLUListElement | null>) => {
  const [applyGradientBefore, setApplyGradientBefore] = useState(false);
  const [applyGradientAfter, setApplyGradientAfter] = useState(false);
  const applyNavGradient = useCallback(() => {
    const seoMenuNav = seoMenuRef.current;

    if (seoMenuNav) {
      const { clientWidth, scrollLeft, scrollWidth } = seoMenuNav;
      const seoMenuMaxWidth = clientWidth < clientMaxWidth ? clientWidth : clientMaxWidth;
      const hasOverflow = scrollWidth > seoMenuMaxWidth;

      if (hasOverflow) {
        setApplyGradientBefore(scrollLeft > 0);
        setApplyGradientAfter(
          scrollLeft === 0 || Math.round(scrollLeft + clientWidth) < scrollWidth
        );
      }
    }
  }, [seoMenuRef]);

  useLayoutEffect(() => {
    if (!isSeoMenu) return;

    const seoMenuNav = seoMenuRef.current;

    if (seoMenuNav) {
      applyNavGradient();

      seoMenuNav.addEventListener('scroll', applyNavGradient);
      window.addEventListener('resize', applyNavGradient);

      return () => {
        seoMenuNav.removeEventListener('scroll', applyNavGradient);
        window.removeEventListener('resize', applyNavGradient);
      };
    }
  }, [isSeoMenu, seoMenuRef, applyNavGradient]);

  return { applyGradientBefore, applyGradientAfter };
};

export default useScrollGradient;
